module.exports = __webpack_public_path__ + "static/pages-48414a4c2e1f6002166c997216539ba2.png";